frontApp.jsRoll = {
  name: 'jsRoll',
  description: 'roll with js',
  isOpen: false,
  init() {
    const elements = document.querySelectorAll('.js-roll');

    if (!elements.length) {
      return;
    }

    const self = this;

    elements.forEach((element) => {
      const content = element.querySelector('.js-roll-content');

      if (!content) {
        return;
      }

      this.checkContentSize(element, content);

      // Отслеживать изменение высоты контента
      let elementWidthPrev = element.offsetWidth;

      function checkContentHeight() {
        const elementWidthCurrent = element.offsetWidth;

        if (elementWidthPrev === elementWidthCurrent) return;

        self.checkContentSize(element, content);

        elementWidthPrev = elementWidthCurrent;
      }

      window.addEventListener('resize', () => {
        checkContentHeight();
      });
    });

    const btns = document.querySelectorAll('.js-roll-btn');

    if (!btns.length) {
      return false;
    }

    btns.forEach((btn) => {
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (this.isOpen) {
          this.close([btn, btn.closest('.js-roll')]);
        } else {
          this.open([btn, btn.closest('.js-roll')]);
        }
      });
    });
  },
  checkContentSize(el, content) {
    if (content.offsetHeight > content.parentElement.offsetHeight) {
      el.classList.add('js-roll--activated');
    } else {
      el.classList.remove('js-roll--activated');
    }
  },
  open(els) {
    this.isOpen = true;
    els.forEach((el) => el.classList.add('is-open'));
  },
  close(els) {
    this.isOpen = false;
    els.forEach((el) => el.classList.remove('is-open'));
  },
};
